import { render, staticRenderFns } from "./PageEditorToolbarContentAreaBtn.vue?vue&type=template&id=128626c5&scoped=true"
import script from "./PageEditorToolbarContentAreaBtn.vue?vue&type=script&lang=js"
export * from "./PageEditorToolbarContentAreaBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128626c5",
  null
  
)

export default component.exports